/**
 * JobDashboard Module - Feature 114-job-infrastructure
 */

import React from 'react';
import { ErrorBoundary } from '../../components/error';
import JobDashboardComponent from './JobDashboard';

// Wrap JobDashboard with ErrorBoundary (T121)
const JobDashboardWithErrorBoundary: React.FC = () => (
  <ErrorBoundary name="JobDashboard" showReportButton={true}>
    <JobDashboardComponent />
  </ErrorBoundary>
);

// Export wrapped version as default
export { JobDashboardWithErrorBoundary as JobDashboard };
export { default as JobDashboardComponent } from './JobDashboard';
export { default as JobList } from './JobList';
export { default as JobStatusBadge } from './JobStatusBadge';
export { default as TriggerJobDialog } from './TriggerJobDialog';
export { default as JobLogs } from './JobLogs';
export { default as JobDetail } from './JobDetail';
export { default as JobSchedules } from './JobSchedules';
